import apiPasswordConf from "../conf/api/ApiPassword.conf";
import passwordUrl from "@/utils/apiUrl/seguridad/password.url";
import interceptor from "../conf/httpinterceptor";
import httpErrorMessage from "@/utils/httpErrorMessage";

export default {
    async changePassword(payload) {
        try {
            let apiPassword = apiPasswordConf.getConfiguration()
            apiPassword.url = passwordUrl.URL_PASSWORD
            apiPassword.body = payload;
            apiPassword.instance = interceptor.getInterceptor(apiPassword.instance)
            let response = await apiPassword.put()
            if(response.data && response.data.status != 200){
                throw new Error(response.data.message ? response.data.message : httpErrorMessage.DEFAULT_ERROR)
            }else if(response.status != 200) throw new Error(response.statusText ? response.statusText : httpErrorMessage.CONECTION_ERROR)
            return response.data
        } catch (error) {
           throw new Error(error.message)
        }
    },

}